/* --------------------------------------------------------------------------
  Copyright (c) 2016, VoiceVibes, Inc

  VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
  All contents of this file are proprietary and confidential. No part of
  any of the contents of this file may be disclosed in any manner to
  a third party without the prior written consent of VoiceVibes, Inc.
  Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

import Home from '../components/pages/Home';

import ConfirmCode from '../components/pages/ConfirmCode';
import Admin from '../components/pages/Admin';
import SignIn from '../components/pages/SignIn';
import BtcSignIn from '../components/pages/BtcSignIn';
import SignUp from '../components/pages/SignUp';
import SignOut from '../components/pages/SignOut';
import ForgotPassword from '../components/pages/ForgotPassword';
import EmailNotifications from '../components/pages/EmailNotifications';
import ResetPassword from '../components/pages/ResetPassword';
import Profile from '../components/pages/Profile';
import Record from '../components/pages/Record';

import Evaluate from '../components/pages/Evaluate';
import EvaluateRecording from '../components/pages/EvaluateRecording';

import Unsubscribe from '../components/pages/Unsubscribe';
import History from '../components/pages/History';

import ReorderAssignments from '../components/pages/ReorderAssignments';
import AssignmentPreview from '../components/pages/AssignmentPreview';
import AssignmentDetails from '../components/pages/AssignmentDetails';
import AssignmentEdit from '../components/pages/AssignmentEdit';
import AssignmentSharedRecordings from '../components/pages/AssignmentSharedRecordings';
import CoachDashboard from '../components/pages/CoachDashboard';
import SpeakerDashboard from '../components/pages/SpeakerDashboard';
import Manage from '../components/pages/Manage';
import Subscription from '../components/pages/Subscription';
import Wordspotting from '../components/pages/Wordspotting';

import Help from '../components/pages/Help';
import ZoomLoading from '../components/pages/ZoomLoading';
import ZoomRecordings from '../components/pages/ZoomRecordings';
import store from '../vuex/store';

export default [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      announcer: 'Home page',
    }
  }, {
    path: '/unsubscribe/:unsubscribeCode',
    name: 'unsubscribe',
    component: Unsubscribe,
    meta: {
      requiresAuth: false,
      hideSignIn: true,
      announcer: 'Unsubscribe',
    }
  }, {
    path: '/sign-up',
    name: 'sign-up',
    component: SignUp,
    meta: {
      signOut: true,
      announcer: 'Sign Up',
    }
  }, {
    path: '/sign-in',
    name: 'sign-in',
    component: SignIn,
    meta: {
      signOut: true,
      hideSignIn: true,
      announcer: 'Sign In',
    }
  }, {
    path: '/btc/sign-in',
    name: 'BtcSignIn',
    component: BtcSignIn,
    meta: {
      requiresAuth: false,
      signOut: false,
      hideSignIn: true,
      announcer: 'Bigtincan Sign In',
    }
  }, {
    path: '/confirm-code',
    name: 'confirm-code',
    component: ConfirmCode,
    meta: {
      requiresAuth: true,
      requiresSubscription: true,
      announcer: 'Join Group',
    }
  }, {
    path: '/sign-out',
    name: 'sign-out',
    component: SignOut,
    meta: {
      signOut: true,
      announcer: 'Sign Out',
    }
  }, {
    path: '/password/forgot',
    name: 'password-forgot',
    component: ForgotPassword,
    meta: {
      hideSignIn: true,
      announcer: 'Forgot Password',
    }
  }, {
    path: '/password/reset',
    name: 'password-reset',
    component: ResetPassword,
    meta: {
      hideSignIn: true,
      announcer: 'Reset Password',
    }
  }, {
    path: '/evaluate',
    name: 'evaluate',
    component: Evaluate,
    meta: {
      requiresAuth: true,
      requiresSubscription: true,
      announcer: 'Recording Results',
    }
  }, {
    path: '/customer-admin/invites',
    name: 'customer-admin-invites',
    component: Admin,
    meta: {
      requiresAuth: true,
      requiresSubscription: true,
      announcer: 'Invites Admin',
    }
  }, {
    path: '/customer-admin/pending-invites',
    name: 'customer-admin-pending-invites',
    component: Admin,
    meta: {
      requiresAuth: true,
      requiresSubscription: true,
      announcer: 'Pending Invites Admin',
    }
  }, {
    path: '/customer-admin/groups/:groupId',
    name: 'customer-admin-groups-groupId',
    component: Admin,
    meta: {
      requiresAuth: true,
      requiresSubscription: true,
      announcer: 'Group Admin',
    }
  }, {
    path: '/customer-admin/groups',
    name: 'customer-admin-groups',
    component: Admin,
    meta: {
      requiresAuth: true,
      requiresSubscription: true,
      announcer: 'Groups Admin',
    }
  }, {
    path: '/customer-admin/users',
    name: 'customer-admin-users',
    component: Admin,
    meta: {
      requiresAuth: true,
      requiresSubscription: true,
      announcer: 'Users Admin',
    }
  }, {
    path: '/customer-admin/users/:userId',
    name: 'customer-admin-users-userId',
    component: Admin,
    meta: {
      requiresAuth: true,
      requiresSubscription: true,
      announcer: 'User Admin',
    }
  }, {
    path: '/customer-admin/users/:userId/:groupId',
    name: 'customer-admin-users-userId-groupId',
    component: Admin,
    meta: {
      requiresAuth: true,
      requiresSubscription: true,
      announcer: 'User Group Admin',
    }
  }, {
    path: '/customer-admin/groups/:groupId/users',
    name: 'customer-admin-users-groupId',
    component: Admin,
    meta: {
      requiresAuth: true,
      requiresSubscription: true,
      announcer: 'Group Users Admin',
    }
  }, {
    path: '/evaluate/:recordingId',
    name: 'evaluate-recording',
    component: EvaluateRecording,
    meta: {
      requiresAuth: true,
      requiresSubscription: true,
      menu: 'evaluate',
      announcer: 'Evaluate Recording',
    }
  }, {
    path: '/history',
    name: 'history',
    component: History,
    meta: {
      requiresAuth: true,
      requiresSubscription: true,
      announcer: 'History',
    }
  }, {
    path: '/wordspotting',
    name: 'wordspotting',
    component: Wordspotting,
    meta: {
      requiresAuth: true,
      requiresSubscription: true,
      announcer: 'Wordspotting',
    }
  }, {
    path: '/manage',
    name: 'manage',
    component: Manage,
    meta: {
      requiresAuth: true,
      requiresSubscription: true,
      announcer: 'Manage',
    }
  }, {
    path: '/assignments/create',
    name: 'create-assignment',
    component: AssignmentEdit,
    meta: {
      requiresAuth: true,
      requiresSubscription: true,
      announcer: 'Create Assignment',
    }
  }, {
    path: '/assignments/:groupId/reorder',
    name: 'reorder-assignments',
    component: ReorderAssignments,
    meta: {
      requiresAuth: true,
      requiresSubscription: true,
      announcer: 'Reorder Assignments',
    }
  }, {
    path: '/assignments/:assignmentId/preview',
    name: 'preview-assignment',
    component: AssignmentPreview,
    meta: {
      requiresAuth: true,
      requiresSubscription: true,
      announcer: 'Preview Assignment',
    }
  }, {
    path: '/assignments/:assignmentId/sharedRecordings',
    name: 'assignment-shared-recordings',
    component: AssignmentSharedRecordings,
    meta: {
      requiresAuth: true,
      requiresSubscription: true,
      announcer: 'Assignment Shared Recordings',
    }
  }, {
    path: '/assignments/edit/:assignmentId/:stepNum',
    name: 'edit-assignment',
    component: AssignmentEdit,
    meta: {
      requiresAuth: true,
      requiresSubscription: true,
      announcer: 'Edit Assignment',
    }
  }, {
    path: '/assignment/details/:assignmentId',
    name: 'assignment-details',
    component: AssignmentDetails,
    meta: {
      requiresAuth: true,
      requiresSubscription: true,
      announcer: 'Assignment Details',
    }
  }, {
    path: '/coach-dashboard',
    name: 'coach-dashboard',
    component: CoachDashboard,
    meta: {
      requiresAuth: true,
      requiresSubscription: true,
      announcer: 'Coach Dashboard',
    }
  }, {
    path: '/speaker-dashboard',
    name: 'speaker-dashboard',
    component: SpeakerDashboard,
    meta: {
      requiresAuth: true,
      requiresSubscription: true,
      announcer: 'Speaker Dashboard',
    }
  }, {
    path: '/email-notifications',
    name: 'email-notifications',
    component: EmailNotifications,
    meta: {
      requiresAuth: true,
      requiresSubscription: true,
      announcer: 'Manage',
    }
  }, {
    path: '/subscription/:groupId',
    name: 'subscription-groupId',
    component: Subscription,
    meta: {
      requiresAuth: true,
      menu: 'manage',
      announcer: 'Subscription',
    }
  }, {
    path: '/subscription',
    name: 'subscription',
    component: Subscription,
    meta: {
      requiresAuth: true,
      menu: 'manage',
      announcer: 'Subscription',
    }
  }, {
    path: '/record',
    name: 'record',
    component: Record,
    meta: {
      requiresAuth: true,
      announcer: 'Record',
    }
  }, {
    path: '/profile',
    name: 'profile',
    component: Profile,
    meta: {
      requiresAuth: true,
      announcer: 'Profile',
    }
  }, {
    path: '/zoom-recordings',
    name: 'zoom-recordings',
    component: ZoomRecordings,
    meta: {
      requiresAuth: true,
      menu: 'record',
      announcer: 'Zoom Setup',
    }
  }, {
    path: '/zoom-loading',
    name: 'zoom-loading',
    component: ZoomLoading,
    meta: {
      requiresAuth: true,
      announcer: 'Zoom Loading',
    }
  }, {
    path: '/join',
    name: 'join',
    meta: {},
    redirect: () => {
      return (store.getters.isAuthenticated) ?
        { name: 'confirm-code' } : { name: 'sign-up' };
    }
  }, {
    path: '/help',
    name: 'help',
    component: Help,
    meta: {
      requiresAuth: true,
      announcer: 'Help',
    }
  }, {
    path: '*',
    meta: {},
    redirect: '/'
  }
];
